import { $InjectorLike } from '@uirouter/core';
import * as angular from 'angular';
import { ILanguageSettings } from '../models/ILanguageSettings';

export class LanguageService {
    private defaultLanguage = 1;

    private languageSettings = {
        1: {
            decimalSeparator: '.',
            groupSeparator: ',',
            currencySign: '£',
            currencyText: 'GBP',
            currencySeparator: '',
            styleClass: 'withPound',
            currencyFracSign: 'p'
        } as ILanguageSettings,
        2: {
            decimalSeparator: ',',
            groupSeparator: ' ',
            currencySign: 'kr',
            currencyText: 'NOK',
            currencySeparator: ' ',
            styleClass: 'withKrona',
            currencyFracSign: 'Øre'
        } as ILanguageSettings,
        3: {
            decimalSeparator: '.',
            groupSeparator: ',',
            currencySign: '$',
            currencyText: 'USD',
            currencySeparator: '',
            styleClass: 'withDollar',
            currencyFracSign: '¢'
        } as ILanguageSettings,
        4: {
            decimalSeparator: '.',
            groupSeparator: ',',
            currencySign: '€',
            currencyText: 'EUR',
            currencySeparator: '',
            styleClass: 'withEuro',
            currencyFracSign: 'с'
        } as ILanguageSettings,
        5: {
            decimalSeparator: '.',
            groupSeparator: ',',
            currencySign: 'AED',
            currencyText: 'AED',
            currencySeparator: ' ',
            styleClass: 'withDirham',
            currencyFracSign: 'fils'
        } as ILanguageSettings
    };

    public getLangSettingsOrDefault(lang: number): ILanguageSettings {
        if (this.languageSettings[lang]) {
            return this.languageSettings[lang];
        }

        return this.languageSettings[this.defaultLanguage];
    }

    public getLangCurrencyStyle(lang: number): string {
        if (this.languageSettings[lang]) {
            return this.languageSettings[lang].styleClass;
        }

        return this.languageSettings[this.defaultLanguage].styleClass;
    }
}

angular.module('app.common').service('languageService', LanguageService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/services/languge.service.ts